<template>
  <div>
    <v-radio-group class="style-checkbox ml-16" :name="name_property" color="info">
      <div v-for="(data, index) in datas.value" :key="index" class="ele-checkbox">
        <v-checkbox
          :label="data"
          :value="data"
          :name="name_property"
          v-model="datas.saveValue"
          @click="checkBoxFunc"
        ></v-checkbox>
        <div v-if="checkedFlg === false">
        <v-text-field
          class="text-field"
          label="その他の場合は入力してください"
          :name="name_property_other"
          :disabled="checkedFlg"
          v-model="datas.saveValueOther"
          required
        ></v-text-field>
        </div>
        <div v-else>
        <v-text-field
          class="text-field"
          label="その他の場合は入力してください"
          :name="name_property_other"
          :disabled="checkedFlg"
          required
        ></v-text-field>
        </div>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'CheckBox',
  components: {
  },
  data () {
    return {
      checkedFlg: true
    }
  },
  props: {
    datas: {
      type: Object,
      required: true
    },
    name_property: {
      type: String,
      required: true
    },
    name_property_other: {
      type: String
    }
  },
  methods: {
    checkBoxFunc: function () {
      if (this.datas.saveValue.includes('その他:')) {
        this.checkedFlg = false
      } else {
        this.checkedFlg = true
      }
    }
  }
}
</script>
